Service = App.loadClass 'core::Angular/Service'

class exports.RowClearingService extends Service
    constructor: (@http, @rootScope) ->
        # Variable Declarations
        # Container for rows that are selected for clearing
        @clear_selections = []
        # Flag that indicates bulk clearing state
        @bulkClearing = false
        # Flag that indicates whether or not all rows have been selected for clearing
        @selectedAll = false
        # Text for the Clear button
        @clearBtnText = 'Bulk Clear'
        # Text for the Select All button
        @selectBtnText = 'Select All'

        # Function Declarations
        @bulkClear = @bulkClear
        @setTableClass = @setTableClass
        @bulkClearSelectAll = @bulkClearSelectAll
        @handleRowClick = @handleRowClick
        @clearSingle = @clearSingle

    bulkClear: () =>
        # if something can be cleared
        if @scope.clear_selections.length > 0
            @handleBulkClear()

        else
            @scope.bulkClearing = not @scope.bulkClearing
            @scope.clearBtnText = if @scope.bulkClearing then 'Cancel Clear' else 'Bulk Clear'

            for row in @scope.rows
                # if record.canClear and @scope.bulkClearing
                if @scope.bulkClearing
                    row.rowClass = 'multidelete alert-success'
                else
                    row.rowClass = ''
                for i, child of @scope.rows.children
                    child.rowClass = 'multidelete alert-success'


    handleBulkClear: () =>
        #show the loader
        msg = @loader.overMap 'Loading...'
        #clear selected records from the view
        for record in @scope.clear_selections
            index = @scope.conversion_records.indexOf(record)
            @scope.conversion_records.splice(index, 1)

        #flag records in the backend via a call to MCS
        @mcs.clearConversionRecords(@scope.clear_selections)
        @scope.clear_selections = []

        @scope.bulkClearing = false
        @bulkClear()
        @setTableClass()
        $(window).trigger 'resize'
        return true


    setTableClass: () =>
        if @scope.bulkClearing
            return 'clickable'
        else
            return 'table-striped'


    bulkClearSelectAll: () =>
        @scope.selectedAll = not @scope.selectedAll
        @scope.clearBtnText = if @scope.selectedAll then 'Clear Selected' else 'Cancel Clear'

        for record in @scope.conversion_records
            if @scope.selectedAll
                if @scope.clear_selections.indexOf(record) is -1 and record.canClear
                    record.rowClass = 'multidelete alert-error'
                    @scope.clear_selections.push(record)
            else
                if record.canClear
                    record.rowClass = 'multidelete alert-success'
                    index = @scope.clear_selections.indexOf(record)
                    @scope.clear_selections.splice(index, 1)


    clearSingle: (record) =>
        #!record.canClear'
        msg = @loader.overMap 'Loading...'
        @scope.clear_selections.push record

        index = @scope.conversion_records.indexOf(record)
        @scope.conversion_records.splice(index, 1)

        @mcs.clearConversionRecords(@scope.clear_selections)
        @scope.clear_selections = []

        $(window).trigger 'resize'
        return true


    handleRowClick: (record) =>
        return if not @scope.bulkClearing

        if record.rowClass is 'multidelete alert-success'
            record.rowClass = 'multidelete alert-error'
            @scope.clear_selections.push(record)

        else if record.rowClass is 'multidelete alert-error'
            record.rowClass = 'multidelete alert-success'
            index = @scope.clear_selections.indexOf(record)
            @scope.clear_selections.splice(index, 1)

        @scope.clearBtnText = if @scope.clear_selections.length > 0 then 'Clear Selected' else 'Cancel Clear'
